import axios from "axios";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import Multiselect from "@vueform/multiselect";
import store from "@/store";
export default {
    name: "importtoformlibrary",
    components: {
        VPagination,
        Multiselect,
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            // Data hub code starts
            showupload: false,
            showLoading: false,
            studyFile: "",
            studyFiles: [],
            dataInput: "",
            showValidation: false,
            idToken: "",
            studyId:"",
            templateId:"",
            selectedTemplateIds: [],
            importvalue: {
                TemplateIds: [],
                StudyId: "",
            },

            azuredata: {
                DocumentId: "",
                DocumentVersionId: "",
                DocumentTypeName: "",
                DocumentTitle: "",
                DocumentDescription: "",
                Document: "",
                OrganizationId: "",
            },
            searchData: {
                fileName: "",
                uploadedBy: "",
                fromDate: "",
                toDate: "",
                status: "",
                pageindex: 1,
                pageSize: 1000,
                SortProperty: "CreatedAt",
                sortorder: 1
            },
            sortorder: 0,
            SortProperty:"TemplateName",
            templateList: [],
            totalCount: 0,
            showUploadModal: false,
            defaultTime: "",
            defaultdate: "",
            currentPage: 1,
            loadNextPage: false,
            totalPages: 1,
            selectedcolumnobj: {},
            showFilter: false,
            dropdownOpen: false,
        };
    },
   async mounted(){
        this.idToken = store.getters.getIdToken;
        this.setstudyid();
        console.log("On mounted")
        await this.Getstudytemplates();
        console.log("On mounted222")
        window.addEventListener("studyIdChanged", (event) => {
                this.setstudyid();
                this.Getstudytemplates();
        });
     
    },
    methods: {
        async setstudyid() {
        this.studyId = store.getters.getStudyIs;
        },
        async Getstudytemplates(){
                    await axios.get(`${this.baseurl}/forms/template/listtemplate?status=Approved&StudyID=${this.studyId}&pageindex=${this.searchData.pageindex}&pagesize=${this.searchData.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
                        {
                            headers: {
                              Authorization: "Bearer " + this.idToken,
                              "Content-Type": "application/json",
                            },
                        }
                    ).then((res) =>{
                        this.templateList = res.data.results;
                        console.log("templateList", this.templateList);
                    }).catch(err => console.log("error in listing templates...", err))
        },
        async ImportFun() {
            this.importvalue.TemplateIds = [];
            this.importvalue.TemplateIds = this.selectedTemplateIds;
            if (
                !this.importvalue.TemplateIds ||
                this.importvalue.TemplateIds.length < 1
            ) {
                alert(this.$t('navigations.no forms selected'));
            } else {
                this.importvalue.StudyId = this.studyId;
                const idtoken = store.getters.getIdToken;
                await axios
                .post(
                    // `https://localhost:5002/template/copytemplateandeditchecks`,
                    `${this.baseurl}/forms/template/copytemplateandeditchecks`,
                    this.importvalue,
                    {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                    }
                )
                .then((res) => {
                    const responseData = res.data;// get the count here
                    alert(`${this.$t('navigations.form imported succesfully')}`);
                    this.selectedTemplateIds = [];
                    
                })
                .catch((err) => {
                    alert(err.response.data.detail);
                });
            }
        },
    },
    
    
}